import React, { useState } from 'react';
import { Alert, IconButton, Tooltip, Box } from '@mui/material';
import { Close, InfoOutlined } from '@mui/icons-material';

interface RejectionBannerProps {
  rejectionReason: string;
  onDismiss?: () => void;
}

const RejectionBanner: React.FC<RejectionBannerProps> = ({ rejectionReason, onDismiss }) => {
  const [visible, setVisible] = useState(true);

  if (!visible || !rejectionReason) return null;

  const handleDismiss = () => {
    setVisible(false);
    onDismiss?.();
  };

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 1200,
        width: '100%',
        mb: 2,
      }}
    >
      <Alert
        severity="warning"
        action={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Tooltip title={rejectionReason} placement="bottom" arrow>
              <IconButton size="small" color="inherit">
                <InfoOutlined />
              </IconButton>
            </Tooltip>
            <IconButton
              size="small"
              color="inherit"
              onClick={handleDismiss}
            >
              <Close fontSize="small" />
            </IconButton>
          </Box>
        }
        sx={{
          '& .MuiAlert-message': {
            width: '100%',
          },
        }}
      >
        <strong>Changes Requested</strong>
        <Box
          component="span"
          sx={{
            display: 'block',
            mt: 0.5,
            fontSize: '0.875rem',
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {rejectionReason}
        </Box>
      </Alert>
    </Box>
  );
};

export default RejectionBanner;
